import { Align, Direction, Justify, SpaceVariant } from '../Common/types';
import { StyledBox } from '../Common/StyledBox';
import { ComponentPropsWithoutRef, ReactNode } from 'react';
import {
  resolveResponsiveProp,
  ResponsiveConditions,
  ResponsiveProp,
  spaceVariantToValue,
} from '../Common/boxUtils';

type ColumnBelowScreenSize = Exclude<keyof ResponsiveConditions<any>, 'mobile'>;

export const resolveFlexDirection = (
  columnBelow?: ColumnBelowScreenSize
): ResponsiveProp<Direction> => {
  if (columnBelow === 'tablet') {
    return { mobile: 'column', tablet: 'row' };
  }
  if (columnBelow === 'desktop') {
    return { mobile: 'column', tablet: 'column', desktop: 'row' };
  }
  if (columnBelow === 'desktopLarge') {
    return {
      mobile: 'column',
      tablet: 'column',
      desktop: 'column',
      desktopLarge: 'row',
    };
  }
  if (columnBelow === 'desktopXLarge') {
    return {
      mobile: 'column',
      tablet: 'column',
      desktop: 'column',
      desktopLarge: 'column',
      desktopXLarge: 'row',
    };
  }
  return 'row';
};

type InlineProps = {
  justify?: ResponsiveProp<Justify>;
  align?: ResponsiveProp<Align>;
  gap?: ResponsiveProp<SpaceVariant>;
  reverse?: boolean;
  children?: ReactNode;
  columnBelow?: ColumnBelowScreenSize;
  as?: 'div' | 'span' | 'ol' | 'ul';
} & ComponentPropsWithoutRef<'div'>;

export const Inline = ({
  children,
  justify,
  align,
  gap,
  reverse,
  columnBelow,
  ...rest
}: InlineProps) => {
  const resolvedGap = spaceVariantToValue(gap);

  return (
    <StyledBox
      $display={'flex'}
      $justify={resolveResponsiveProp<Justify, Justify>(justify)}
      $align={resolveResponsiveProp<Align, Align>(align)}
      $flexDirection={resolveResponsiveProp<Direction, Direction>(
        resolveFlexDirection(columnBelow)
      )}
      $gap={resolvedGap}
      $reverse={reverse}
      $flexWrap
      {...rest}
    >
      {children}
    </StyledBox>
  );
};
